import ChatArea from './ChatArea';

export default ChatArea; 